const constants = {
    OK: 200,
    NO_DATA: 204,
    BAD_REQUEST: 400,
    NOT_FOUND: 404,
    INTERNAL_ERROR: 500,
    API_ERROR: "API_ERROR"
}

export default constants;